/** Human labels and badge styles for WhatsApp session stages/states. */

export const STAGE_ORDER = [
  'reg_name',
  'reg_email',
  'reg_confirm',
  'menu',
  'sandbox_menu',
  'origin',
  'destination',
  'trip_type',
  'date',
  'return_date',
  'pax_count',
  'fare_select',
  'pax_pick',
  'pax_details',
  'confirm',
  'payment',
  'complete',
];

export const STAGE_LABELS = {
  reg_name: 'Registration — name',
  reg_email: 'Registration — email',
  reg_confirm: 'Registration — confirm',
  menu: 'Main menu',
  sandbox_menu: 'Sandbox menu',
  origin: 'Origin city',
  destination: 'Destination',
  trip_type: 'Trip type',
  date: 'Departure date',
  return_date: 'Return date',
  pax_count: 'Passenger count',
  fare_select: 'Select flight',
  pax_pick: 'Pick saved traveller',
  pax_details: 'Passenger details',
  confirm: 'Confirm booking',
  payment: 'Payment',
  complete: 'Complete',
};

export const STATE_LABELS = {
  identifying: 'Identifying',
  registering: 'Registering',
  menu: 'Menu',
  collecting: 'Booking',
  payment_pending: 'Awaiting payment',
  booked: 'Booked',
  agent_mode: 'With agent',
  idle: 'Idle',
};

export function stageLabel(stage) {
  return STAGE_LABELS[stage] || stage || '—';
}

export function stateLabel(state) {
  return STATE_LABELS[state] || state || '—';
}

export function stageBadgeClass(stage) {
  const map = {
    payment: 'bg-amber-100 text-amber-800',
    confirm: 'bg-blue-100 text-blue-800',
    pax_details: 'bg-violet-100 text-violet-800',
    pax_pick: 'bg-violet-100 text-violet-800',
    fare_select: 'bg-indigo-100 text-indigo-800',
    complete: 'bg-emerald-100 text-emerald-800',
    agent_mode: 'bg-red-100 text-red-800',
  };
  return map[stage] || 'bg-gray-100 text-gray-700';
}

export function stateBadgeClass(state) {
  if (state === 'agent_mode') return 'bg-red-100 text-red-800';
  if (state === 'booked') return 'bg-emerald-100 text-emerald-800';
  if (state === 'payment_pending') return 'bg-amber-100 text-amber-800';
  return 'bg-teal-50 text-[#1B375B]';
}

export function formatInr(n) {
  if (n === null || n === undefined) return '—';
  try {
    return `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
  } catch {
    return `₹${n}`;
  }
}
